import { c as _c } from "react/compiler-runtime";
import type { Volume } from "@/lib/volume";
const timestampFormat = new Intl.DateTimeFormat("en-GB", {
  dateStyle: "medium",
  timeStyle: "short",
  timeZone: "UTC"
});
export function VolumeStaleWarning(t0) {
  const $ = _c(5);
  const {
    fetchedAt,
    isStale
  } = t0;
  if (!isStale) {
    return null;
  }
  let t1;
  if ($[0] !== fetchedAt) {
    t1 = timestampFormat.format(new Date(fetchedAt));
    $[0] = fetchedAt;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== fetchedAt || $[3] !== t1) {
    t2 = <p role="status" className="text-center text-xs text-amber-700 dark:text-amber-400">Volume data is out of date. We couldn't refresh it. Last fetched{" "}<time dateTime={fetchedAt}>{t1} UTC</time>.</p>;
    $[2] = fetchedAt;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}